import { api } from '@/lib/api/client'

export interface SearchHit {
  type: 'work_item' | 'project' | 'client'
  id: string
  key: string | null
  title: string
  subtitle: string | null
  url: string
}

export async function search(query: string): Promise<SearchHit[]> {
  const { data } = await api.get<{ data: SearchHit[] }>('/search', { params: { q: query } })

  return data.data
}
